export function mapper(data: any) {
  return data.map((row: any) => ({
    รหัสและชื่อบัญชี: row.name,
    ...Object.keys(row.budgets).reduce((prev, name) => ({ ...prev, [name]: row.budgets[name].budget }), {}),
    รวม: row.total,
  }));
}
